
<div class="em-block">
  <div class="em-child">
    <div class="row">
      <div class="col">
        <h2>Limits</h2>
        <hr />
      </div>
    </div>
    <view-settings-limit
      v-for="(limit, key, index) in limits"
      v-on:showConditionalRuleModal="showConditionalRuleModal"
      :limit="limit"
      :key="key"
      :index="index"
    ></view-settings-limit>
    <div class="cta">
      <button class="btn grey-to-blue" @click="addLimit">+ Add Limit</button>
    </div>
  </div>
  <conditional-display-modal
    v-if="selectedRuleSet"
    :parent="selectedLimit"
    :ruleSet="selectedRuleSet"
    :state="modalStateFor(vueModalID.conditionalDisplay)"
    :index="vueModalID.conditionalDisplay"
    :key="selectedRuleSet.client_id"
    @toggle-modal="hideConditionalDisplayModal"
  ></conditional-display-modal>
</div>
